export const heroData = {
  title: '科学认识女性分泌物',
  subtitle: '用专业科普视频，帮助每一位女性了解自身生理健康',
  description: '爱液视频汇聚国内权威妇科专家，提供爱液成分分析、分泌机制讲解、健康判断标准等专业科普内容，让你的私密健康知识不再空白。',
  stats: [
    { value: '500+', label: '科普视频' },
    { value: '200万+', label: '累计观看' },
    { value: '50+', label: '专家入驻' },
    { value: '98%', label: '好评率' },
  ],
};

export const featuredVideos = [
  {
    id: 'aiye-chengfen-xiangjie',
    title: '爱液成分详解：你的分泌物里有什么？',
    coverImage: 'https://readdy.ai/api/search-image?query=Scientific%20abstract%20closeup%20of%20clear%20droplet%20on%20soft%20silk%20texture%2C%20warm%20peach%20and%20cream%20background%2C%20minimalist%20medical%20aesthetic%2C%20soft%20diffused%20lighting%2C%20macro%20photography%20style%2C%20clean%20composition%2C%20feminine%20health%20concept&width=640&height=360&seq=featured-video-01&orientation=landscape',
    category: '爱液成分',
    categorySlug: 'aiye-chengfen',
    duration: '08:32',
    views: '12.8万',
    expert: '王芳 主任医师',
    description: '深入解析爱液中水分、酶类、电解质等成分构成，了解每种成分的生理功能。',
  },
  {
    id: 'fenmi-jizhi-kepu',
    title: '女性分泌机制全解析：从生理周期到健康信号',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20flowing%20organic%20shapes%20in%20soft%20coral%20and%20cream%20tones%2C%20biological%20texture%20inspired%20pattern%2C%20gentle%20gradient%20background%2C%20medical%20illustration%20aesthetic%2C%20warm%20and%20soothing%20atmosphere%2C%20feminine%20wellness%20concept&width=640&height=360&seq=featured-video-02&orientation=landscape',
    category: '分泌机制',
    categorySlug: 'fenmi-jizhi',
    duration: '12:15',
    views: '9.6万',
    expert: '李雪 副主任医师',
    description: '从激素调节到腺体分泌，全面讲解女性生殖系统分泌的生理机制。',
  },
  {
    id: 'jiankang-panduan-biaozhun',
    title: '如何判断爱液是否健康？颜色与气味指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Delicate%20watercolor%20style%20medical%20illustration%20with%20soft%20peach%20and%20ivory%20color%20palette%2C%20abstract%20cellular%20patterns%2C%20gentle%20organic%20shapes%2C%20clean%20minimalist%20composition%2C%20warm%20lighting%2C%20feminine%20health%20concept&width=640&height=360&seq=featured-video-03&orientation=landscape',
    category: '健康判断',
    categorySlug: 'jiankang-panduan',
    duration: '06:48',
    views: '15.3万',
    expert: '张敏 主任医师',
    description: '通过颜色、气味、质地三大维度，教你科学判断分泌物是否正常。',
  },
  {
    id: 'richang-huli-zhinan',
    title: '私密日常护理指南：避开这些常见误区',
    coverImage: 'https://readdy.ai/api/search-image?query=Calm%20minimalist%20bathroom%20scene%20with%20soft%20natural%20light%2C%20clean%20white%20towels%2C%20gentle%20organic%20cotton%20textures%2C%20warm%20cream%20and%20beige%20tones%2C%20spa-like%20atmosphere%2C%20feminine%20self-care%20concept%2C%20editorial%20photography&width=640&height=360&seq=featured-video-04&orientation=landscape',
    category: '日常护理',
    categorySlug: 'richang-huli',
    duration: '10:20',
    views: '18.7万',
    expert: '陈玲 主治医师',
    description: '私密护理的正确方法，避开过度清洁、错误用品等常见误区。',
  },
];

export const categories = [
  {
    slug: 'aiye-chengfen',
    name: '爱液成分',
    description: '了解分泌物的化学构成与功能',
    icon: 'ri-test-tube-line',
    count: 86,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20molecular%20structure%20in%20soft%20peach%20and%20cream%20tones%2C%20scientific%20illustration%20style%2C%20minimalist%20medical%20aesthetic%2C%20clean%20white%20background%2C%20gentle%20lighting%2C%20feminine%20health%20concept&width=400&height=300&seq=category-01&orientation=landscape',
  },
  {
    slug: 'fenmi-jizhi',
    name: '分泌机制',
    description: '从激素到腺体的完整分泌链条',
    icon: 'ri-mental-health-line',
    count: 64,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20flowing%20biological%20patterns%20in%20warm%20amber%20and%20ivory%20tones%2C%20organic%20wave%20textures%2C%20medical%20illustration%20aesthetic%2C%20minimalist%20composition%2C%20soft%20gradient%20background%2C%20feminine%20wellness&width=400&height=300&seq=category-02&orientation=landscape',
  },
  {
    slug: 'jiankang-panduan',
    name: '健康判断',
    description: '学会科学自检，读懂身体信号',
    icon: 'ri-heart-pulse-line',
    count: 72,
    image: 'https://readdy.ai/api/search-image?query=Delicate%20abstract%20health%20monitoring%20concept%20in%20soft%20coral%20and%20cream%20tones%2C%20minimalist%20data%20visualization%20patterns%2C%20clean%20medical%20aesthetic%2C%20warm%20lighting%2C%20feminine%20health%20concept&width=400&height=300&seq=category-03&orientation=landscape',
  },
  {
    slug: 'richang-huli',
    name: '日常护理',
    description: '科学护理方法，避开认知误区',
    icon: 'ri-leaf-line',
    count: 58,
    image: 'https://readdy.ai/api/search-image?query=Calm%20minimalist%20self-care%20scene%20with%20organic%20cotton%20textures%20in%20warm%20beige%20and%20cream%20tones%2C%20natural%20light%2C%20clean%20spa%20aesthetic%2C%20soft%20focus%2C%20feminine%20wellness%20concept&width=400&height=300&seq=category-04&orientation=landscape',
  },
  {
    slug: 'shengzhi-jiankang',
    name: '生殖健康',
    description: '全面了解女性生殖系统知识',
    icon: 'ri-women-line',
    count: 95,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20anatomical%20illustration%20in%20soft%20terracotta%20and%20cream%20tones%2C%20minimalist%20medical%20art%20style%2C%20gentle%20organic%20shapes%2C%20clean%20composition%2C%20warm%20lighting%2C%20feminine%20health%20education&width=400&height=300&seq=category-05&orientation=landscape',
  },
  {
    slug: 'xingjiaoyu',
    name: '性教育',
    description: '科学的性知识与健康观念培养',
    icon: 'ri-book-open-line',
    count: 43,
    image: 'https://readdy.ai/api/search-image?query=Soft%20educational%20illustration%20with%20abstract%20book%20and%20nature%20elements%20in%20warm%20peach%20and%20cream%20tones%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20feminine%20health%20education%20concept&width=400&height=300&seq=category-06&orientation=landscape',
  },
];

export const hotArticles = [
  {
    id: 'zhengchang-aiye-yanse',
    title: '正常爱液的颜色有哪些？从透明到乳白的科学解读',
    excerpt: '很多女性对分泌物的颜色变化感到困惑。透明、白色、淡黄，哪些是正常的？本文从生理学角度为你全面解读。',
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20watercolor%20gradient%20from%20clear%20to%20milky%20white%20in%20abstract%20style%2C%20warm%20peach%20undertone%2C%20minimalist%20medical%20illustration%2C%20gentle%20texture%2C%20feminine%20health%20concept&width=320&height=200&seq=article-01&orientation=landscape',
    category: '健康判断',
    categorySlug: 'jiankang-panduan',
    readTime: '6分钟',
    publishDate: '2026-07-28',
    views: '25.3万',
  },
  {
    id: 'aiye-yuchanqi-bianhua',
    title: '孕期爱液变化全记录：每个阶段需要注意什么',
    excerpt: '怀孕期间，女性分泌物会发生一系列变化。了解这些变化，有助于准妈妈们更好地监测自身和胎儿的健康状况。',
    coverImage: 'https://readdy.ai/api/search-image?query=Gentle%20abstract%20maternity%20concept%20in%20soft%20peach%20and%20cream%20tones%2C%20organic%20flowing%20shapes%2C%20warm%20natural%20light%2C%20minimalist%20composition%2C%20feminine%20wellness&width=320&height=200&seq=article-02&orientation=landscape',
    category: '分泌机制',
    categorySlug: 'fenmi-jizhi',
    readTime: '10分钟',
    publishDate: '2026-07-25',
    views: '19.8万',
  },
  {
    id: 'sichu-qingjie-wuqu',
    title: '私处清洁五大误区，90%的女性都中招了',
    excerpt: '使用洗液、频繁冲洗、香味护垫……这些看似"卫生"的习惯，可能正在伤害你的私密健康。专家告诉你正确的护理方法。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20bathroom%20product%20photography%20in%20warm%20beige%20tones%2C%20organic%20cotton%20textures%2C%20soft%20natural%20lighting%2C%20spa-like%20atmosphere%2C%20feminine%20self-care%20concept&width=320&height=200&seq=article-03&orientation=landscape',
    category: '日常护理',
    categorySlug: 'richang-huli',
    readTime: '7分钟',
    publishDate: '2026-07-22',
    views: '32.1万',
  },
  {
    id: 'yuejing-zhouqi-fenmiwu',
    title: '月经周期与分泌物变化：一份完整的对照表',
    excerpt: '从月经期到排卵期再到黄体期，分泌物在每个月都有规律可循。掌握这个规律，你就是自己最好的健康管家。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20cyclical%20pattern%20in%20soft%20coral%20and%20cream%20tones%2C%20flowing%20circular%20design%2C%20minimalist%20medical%20illustration%2C%20warm%20gentle%20lighting%2C%20feminine%20health%20cycle%20concept&width=320&height=200&seq=article-04&orientation=landscape',
    category: '分泌机制',
    categorySlug: 'fenmi-jizhi',
    readTime: '8分钟',
    publishDate: '2026-07-20',
    views: '28.6万',
  },
  {
    id: 'nianling-fenmiwu-bianhua',
    title: '不同年龄段的分泌物特征：从青春期到更年期',
    excerpt: '20岁、30岁、40岁、50岁……每个年龄段的女性分泌物都有不同特点。了解这些变化，帮助你从容应对人生各阶段。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20concept%20in%20warm%20terracotta%20and%20cream%20tones%2C%20flowing%20organic%20shapes%20showing%20progression%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20feminine%20life%20stages&width=320&height=200&seq=article-05&orientation=landscape',
    category: '生殖健康',
    categorySlug: 'shengzhi-jiankang',
    readTime: '9分钟',
    publishDate: '2026-07-18',
    views: '16.4万',
  },
  {
    id: 'aiye-yichang-xinhao',
    title: '这些分泌物异常信号，可能提示妇科问题',
    excerpt: '豆腐渣样、黄绿色、带血丝……不同异常表现对应不同的健康问题。学会识别这些信号，及时就医很重要。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20medical%20alert%20concept%20in%20soft%20coral%20and%20ivory%20tones%2C%20minimalist%20warning%20pattern%2C%20clean%20composition%2C%20warm%20lighting%2C%20feminine%20health%20awareness%20concept&width=320&height=200&seq=article-06&orientation=landscape',
    category: '健康判断',
    categorySlug: 'jiankang-panduan',
    readTime: '11分钟',
    publishDate: '2026-07-15',
    views: '35.7万',
  },
];

export const faqs = [
  {
    question: '什么是爱液？它主要由什么成分构成？',
    answer: '爱液是女性生殖系统分泌的一种正常生理液体，主要由水分（约90-95%）、电解质（钠、钾、氯等）、有机化合物（尿素、乳酸、蛋白质等）、酶类和脱落的上皮细胞等组成。它的成分和性质会随月经周期、激素水平、年龄等因素发生变化。',
  },
  {
    question: '正常爱液的味道和颜色应该是怎样的？',
    answer: '正常爱液通常呈透明或乳白色，质地可以从稀薄到粘稠不等。气味通常是轻微酸味或无味，这是因为健康的阴道环境呈弱酸性（pH 3.8-4.5）。颜色和气味会随月经周期有所变化，但如果出现黄绿色、灰色、豆腐渣样或有明显鱼腥味、恶臭，建议及时就医。',
  },
  {
    question: '爱液分泌量多少算正常？太多或太少有问题吗？',
    answer: '正常爱液每日分泌量约1-4毫升，但个体差异很大。排卵期、性兴奋时分泌量会增加，这是正常的生理反应。如果分泌量突然剧烈增加并伴有异味、瘙痒，或绝经后明显减少导致干涩不适，建议咨询医生。每个人的"正常"不同，关键是了解自己的基线水平。',
  },
  {
    question: '爱液视频的内容是否经过专业审核？',
    answer: '是的，我们平台的所有科普视频均由国内三甲医院妇科、生殖医学科的专家团队审核把关。每期内容都经过严格的专业审查流程，确保信息的科学性和准确性。同时，我们定期邀请主任医师级别的专家参与内容录制和直播答疑，为用户提供权威可靠的健康知识。',
  },
  {
    question: '如何区分正常分泌物和病理性的异常分泌物？',
    answer: '正常分泌物通常无色或乳白色、无异味或轻微酸味、不引起瘙痒和灼热感。病理性分泌物常伴有以下特征：颜色异常（黄绿、灰白、带血）、气味异常（鱼腥味、恶臭）、质地异常（豆腐渣样、大量泡沫状）、伴随症状（外阴瘙痒、灼痛、下腹痛）。出现以上任何异常，建议尽快就医。',
  },
  {
    question: '平台上的视频可以免费观看吗？',
    answer: '爱液视频坚持公益科普的初心，平台上绝大部分内容均为免费观看。我们相信女性生理健康知识应该被广泛传播，而不是设置门槛。部分专家深度课程可能采用会员制，但基础的科普视频始终免费向所有用户开放。',
  },
];

export const brandInfo = {
  name: '爱液视频',
  slogan: '科学认识自己，从了解开始',
  founded: '2023年',
  mission: '我们致力于打造中国最专业的女性生理健康科普平台，用科学的视角、通俗的语言、温暖的方式，帮助每一位女性了解自身分泌物知识，消除认知盲区，建立科学的私密健康观念。',
  story: '爱液视频由一群关注女性健康的医疗从业者和科普创作者共同发起。创始团队在临床工作中发现，大量女性对自己的生理分泌物缺乏基本了解，很多本可预防的妇科问题因为"不好意思"而延误诊治。我们决定打破这种沉默——以专业视频为载体，让女性生理健康知识变得可触及、可理解、可讨论。',
  values: [
    { title: '科学严谨', description: '所有内容经三甲医院专家审核，确保信息准确可靠', icon: 'ri-shield-check-line' },
    { title: '温暖包容', description: '用尊重、温暖的态度对待每一位用户的疑问和困惑', icon: 'ri-heart-line' },
    { title: '通俗易懂', description: '把专业医学知识转化为大众能理解的语言和画面', icon: 'ri-lightbulb-line' },
    { title: '隐私保护', description: '严格保护用户隐私，营造安全可信的科普环境', icon: 'ri-lock-line' },
  ],
  reviews: [
    {
      name: '小陈',
      age: 28,
      comment: '以前对自己的分泌物变化总是很焦虑，看了爱液视频的科普后，终于知道哪些是正常的了，心里踏实多了。',
      rating: 5,
    },
    {
      name: '李女士',
      age: 35,
      comment: '作为两个孩子的妈妈，我在这里学到了很多之前不知道的知识。孕期那期视频特别实用，推荐给了很多朋友。',
      rating: 5,
    },
    {
      name: '大学生小王',
      age: 21,
      comment: '学校性教育太匮乏了，爱液视频弥补了这块空白。内容专业又不尴尬，讲解方式也很让人舒服。',
      rating: 5,
    },
    {
      name: '张医生',
      age: 42,
      comment: '作为妇科医生，我很认可这个平台的内容质量。把正确的知识用视频传播，对提升女性健康素养很有帮助。',
      rating: 5,
    },
    {
      name: '退休教师刘阿姨',
      age: 58,
      comment: '女儿推荐我看的，学到了很多更年期相关的知识。原来这个年纪的变化也是正常的，不再焦虑了。',
      rating: 4,
    },
  ],
};